interface Props {
    className: string;
    onClick?: any;
    title?: string;
}
export default function emfFilterIcon({className, onClick, title }: Props) {
    return (
        <svg onClick={onClick} className={className} id="filter" xmlns="http://www.w3.org/2000/svg" width="13.822" height="15.463" viewBox="0 0 13.822 15.463">
            <title>{title}</title>
            <g data-name="Group 184953" transform="translate(0.921 0.5)">
                <g data-name="Group 184955">
                    <path data-name="Path 26622" d="M8.813,14.751,5.93,12.73V7.751L1.381.75h11.98l-4.549,7Z" transform="translate(-1.381 -0.75)" fill="none" stroke="currentColor" strokeWidth="1" />
                </g>
            </g>
        </svg>
    )
}